<template>
  <div
    class="v-select-option"
    @click.prevent="handleClick"
  >
    <slot>{{ value }}</slot>
  </div>
</template>

<script>
export default {
  name: 'VSelectOption',
  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  },
  methods: {
    handleClick() {
      this.$emit('choose', this.value)
    }
  }
}
</script>
